"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
const WarningsComponent_vue_1 = require("./WarningsComponent.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'select-option',
    props: {
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    components: {
        AppButton: AppButton_vue_1.default,
        WarningsComponent: WarningsComponent_vue_1.default,
    },
    methods: {
        saveData() {
            this.onsave({ type: 'option' });
        },
    },
});
